/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { DateFormatOptions } from "./DateFormatOptions";

/**
 * Converts a UTC date to a local date and time string using the provided options.
 * @param date The date to convert.
 * @param options The options for formatting the date.
 * @returns The formatted local date and time string.
 */
export const toLocalDateTime = (date: Date, options: DateFormatOptions): string => {
    return Intl.DateTimeFormat(options.locale, {
        timeZone: options.timeZone ? options.timeZone : "UTC",
        year: options.format?.year ?? "numeric",
        month: options.format?.month ?? "short",
        day: options.format?.day ?? "numeric",
        hour: options.format?.hour ?? "numeric",
        minute: options.format?.minute ?? "2-digit",
        hour12: options.format?.hour12 ?? true
    }).format(date);
};
